(function () {
  "use strict";

  /**
   * @module servicesSearchForm
   * Handles the initialization and behaviour of the Services Search Form,
   * including Funnelback autocomplete, honeypot protection, and query formatting.
   */
  const servicesSearchForm = {};

  /**
   * Initialize the Services Search Form functionality
   */
  servicesSearchForm.init = function () {
    console.log("Services search initialised");
    // -----------------------------
    // Config: Links and site metadata
    // -----------------------------
    const serviceFinderUrl =
      typeof sfLinks !== "undefined" ? sfLinks.servicesHome : "";
    const serviceSearchUrl =
      typeof sfLinks !== "undefined" ? sfLinks.servicesSearch : "";
    const sfHHS =
      typeof site !== "undefined" && site.metadata && site.metadata.sfHHS
        ? site.metadata.sfHHS.value
        : "";

    // -----------------------------
    // Select form elements
    // -----------------------------
    const searchForm = document.querySelector(
      ".qld__service-finder--autocomplete",
    );
    if (!searchForm) return; // Exit if no form found

    const queryInput = searchForm.querySelector('input[name="query"]'); // Main search input
    const honeypot = searchForm.querySelector(".qld__text-input--validation"); // Hidden honeypot input
    const searchBtn = searchForm.querySelector(".qld__btn--search"); // Search button
    const typeaheadInput = $(
      ".qld__service-finder--autocomplete input.qld__text-input",
    ); // jQuery input for typeahead

    // -----------------------------
    // Enable form elements
    // -----------------------------
    if (searchBtn) searchBtn.type = "submit";
    searchForm
      .querySelectorAll(".qld__btn--search, .qld__text-input")
      .forEach((el) => el.removeAttribute("disabled"));

    // -----------------------------
    // Clean query value on page load
    // - Remove placeholder "!padrenul"
    // - Remove trailing "*" if exists
    // -----------------------------
    if (queryInput) {
      let value = queryInput.value;
      if (value === "!padrenul") value = "";
      if (value.endsWith("*")) value = value.slice(0, -1);
      queryInput.value = value;
    }

    // -----------------------------
    // Reset honeypot field
    // -----------------------------
    if (honeypot) honeypot.value = "";

    // -----------------------------
    // Form submission handler
    // - Adds wildcard (*) to queries
    // - Adds "!padrenul" if empty
    // - Prevents submission if honeypot is filled
    // -----------------------------

    searchForm.addEventListener("submit", (event) => {
      console.log("Form submit handler triggered");
      event.preventDefault();

      // Stop submission if honeypot is filled
      if (honeypot && honeypot.value !== "") return;
      if (honeypot) honeypot.removeAttribute("name");

      const params = new URLSearchParams(new FormData(searchForm));
      let query = params.get("query");

      if (!query || query.trim() === "") {
        params.set("query", "!padrenul");
      } else {
        params.set("query", query.trim() + "*");
      }

      // Redirect with updated query
      window.location.href = `${searchForm.action}?${params.toString()}`;
    });

    // -----------------------------
    // Funnelback autocomplete configuration
    // -----------------------------
    const fbUrl = "https://qh-search.funnelback.squiz.cloud/s/search.html";
    const fbForm = "qc";
    const fbNumRanks = 4;

    // Collections and profiles
    const collections = {
      services: "qh~sp-core-service-finder__services",
      facilities: "qh~sp-core-service-finder__facilities",
      locations: "qh~sp-core-service-finder__service-locations",
    };

    const profiles = {
      services: "ac-core-service-finder__services",
      facilities: "ac-core-service-finder__facilities",
      locations: "ac-core-service-finder__service-locations",
    };

    // Geolocation for proximity sorting
    const coords = $("#query-origin").val();

    // Get stored user location from localStorage
    const userLocationData = JSON.parse(
      QLD.utils.getLocalStorage("qld_user_location"),
    );
    const currUserLocation = userLocationData ? userLocationData.location : "";

    const currQ = { services: "", facilities: "", locations: "" }; // Used for "See more" links

    // -----------------------------
    // Helper: Build Funnelback API URL
    // -----------------------------
    function buildUrl(collection, profile, query, extra = "") {
      return `${fbUrl}?collection=${collection}&profile=${profile}&form=${fbForm}&num_ranks=${fbNumRanks}&query=${query}${extra}&meta_hhsid_orsand=${sfHHS}`;
    }

    // -----------------------------
    // Helper: Autocomplete suggestion template
    // -----------------------------
    function suggestionTemplate(link) {
      return function (data) {
        return `
                    <div class="qld__search__autocomplete__suggestion tt-suggestion tt-selectable">
                        <a href="${link}${data.path}">
                            <strong class="tt-highlight">${data.disp}</strong>
                        </a>
                    </div>
                `;
      };
    }

    // -----------------------------
    // Helper: Autocomplete "not found" template
    // -----------------------------
    function notFoundTemplate(title) {
      return `
                <h4 class="tt-category">${title}</h4>
                <div class="qld__search__autocomplete__no-suggestions">
                    <em>No suggestions found</em>
                </div>
            `;
    }

    // -----------------------------
    // Initialise Typeahead
    // -----------------------------
    if (serviceFinderUrl || serviceSearchUrl) {
      typeaheadInput.typeahead("destroy"); // Reset any previous typeahead

      typeaheadInput.typeahead(
        {
          hint: false,
          highlight: true,
          minLength: 3,
          limit: 4,
        },

        /* SERVICES */
        {
          name: "services",
          displayKey: "disp",
          source(query, sync, async) {
            const q = `${query}*`;
            currQ.services = q;
            $.getJSON(
              buildUrl(collections.services, profiles.services, q),
              async,
            );
          },
          templates: {
            header: () => `<h4 class="tt-category">Services</h4>`,
            suggestion: suggestionTemplate(`${serviceFinderUrl}/`),
            notFound: () => notFoundTemplate("Services"),
            footer: () => `
                        <div class="more-results">
                            <a href="${serviceSearchUrl}?query=${currQ.services}&collection=${collections.services}" 
                               class="qld__btn qld__btn--primary qld__search__autocomplete__see-more">
                               <span class="qld__search__submit-btn-text">See more</span>
                               <span class="sr-only">results for your query within services</span>
                            </a>
                        </div>
                    `,
          },
        },

        /* FACILITIES */
        {
          name: "facilities",
          displayKey: "disp",
          source(query, sync, async) {
            const q = `${query}*`;
            currQ.facilities = q;
            $.getJSON(
              buildUrl(collections.facilities, profiles.facilities, q),
              async,
            );
          },
          templates: {
            header: () =>
              `<h4 class="tt-category">Hospitals and Health Services</h4>`,
            suggestion: suggestionTemplate(`${serviceFinderUrl}/locations/`),
            notFound: () => notFoundTemplate("Hospitals and Health Services"),
            footer: (query) => `
                        <div class="more-results">
                            <a href="${serviceSearchUrl}?query=${currQ.facilities}&collection=${collections.facilities}" 
                               class="qld__btn qld__btn--primary qld__search__autocomplete__see-more">
                               <span class="qld__search__submit-btn-text">See more</span>
                            </a>
                        </div>
                    `,
          },
        },

        /* SERVICE LOCATIONS */
        {
          name: "service-locations",
          displayKey: "disp",
          source(query, sync, async) {
            const q = `${query}*`;
            currQ.locations = q;
            $.getJSON(
              buildUrl(
                collections.locations,
                profiles.locations,
                q,
                `&origin=${coords}&sort=prox`,
              ),
              async,
            );
          },
          templates: {
            header: () =>
              `<h4 class="tt-category">Near ${currUserLocation}</h4>`,
            suggestion: suggestionTemplate(`${serviceFinderUrl}/`),
            notFound: () => notFoundTemplate(`Near ${currUserLocation}`),
            footer: (query) => `
                        <div class="more-results">
                            <a href="${serviceSearchUrl}?query=${currQ.locations}&collection=${collections.locations}" 
                               class="qld__btn qld__btn--primary qld__search__autocomplete__see-more">
                               <span class="qld__search__submit-btn-text">See more</span>
                            </a>
                        </div>
                    `,
          },
        },
      );
    }
  };

  // Expose module
  QLD.servicesSearchForm = servicesSearchForm;

  document.addEventListener("DOMContentLoaded", function () {
    const form = document.querySelector(".qld__service-finder--autocomplete");
    if (form) {
      servicesSearchForm.init();
    }
  });
})();
